import { red } from "@mui/material/colors"
import { styled } from "@mui/system"
import { useRef, useEffect, useCallback, useMemo } from "react"
import { makeVertexClipPath } from "./shapes"

const StyledVertexSelector = styled('div')({
  display: 'flex',
  position: 'absolute',
  width: '100%',
  height: '100%',
  zIndex: 1000,
  mixBlendMode: 'overlay',
  background: red[500],
  '&:hover': {
    background: red[700]
  }
})

const VertexSelector = ({ x, y, vertexIndex, onVertexHover, getShapeClipPath, moveVertex }) => {
  const selectorRef = useRef()
  const vertexClipPath = useMemo(() => makeVertexClipPath(x, y), [x, y])

  const handleVertexMove = useCallback((vertexIndex, x, y) => moveVertex(vertexIndex, x, y), [moveVertex])

  const handleVertexHover = useCallback((vertexIndex) => {
    if (vertexIndex === null) {
      onVertexHover(false)
    } else {
      onVertexHover({
        vertexIndex,
        move: handleVertexMove,
        getShapeClipPath
      })  
    }
  }, [handleVertexMove, onVertexHover, getShapeClipPath])

  /* HOVER DETECTION (mouse enter/leave) */
  useEffect(() => {
    const handleEnter = () => handleVertexHover(vertexIndex)
    const handleLeave = () => handleVertexHover(null)
    const element = selectorRef.current
    element.addEventListener('mouseenter', handleEnter, { passive: true })
    element.addEventListener('mouseleave', handleLeave, { passive: true })
    return () => {
      element.removeEventListener('mouseenter', handleEnter, { passive: true })
      element.removeEventListener('mouseleave', handleLeave, { passive: true })  
    }
  }, [vertexIndex, handleVertexHover])

  return (
    <StyledVertexSelector
      ref={selectorRef}
      style={{ clipPath: vertexClipPath }}
    />
  )
}

export default VertexSelector